<template>
  <div
    v-if="flavors && flavors.length > 0"
    class="coa-list grid grid-col-4 col-span-4"
  >
    <div v-for="(flavor, name) in formattedFlavors" :key="`flavor-${name}`">
      <coa-item :flavor="flavor"></coa-item>
    </div>
  </div>
</template>

<script>
import CoaItem from '~/components/coa-item.vue'

export default {
  name: 'CoaList',

  components: {
    CoaItem
  },

  props: {
    flavors: {
      default: () => [],
      type: Array
    }
  },

  computed: {
    formattedFlavors() {
      const flavors = {}

      this.flavors.forEach(function(flavor) {
        const name = flavor.product.title

        flavors[name] = flavors[name] ?? {
          name,
          product: flavor.product,
          coas: []
        }

        flavors[name].coas.push({
          lotCode: flavor.lotCode,
          coaUrl: flavor.coa.url
        })
      })

      return flavors
    }
  }
}
</script>

<style scoped>
.coa-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
